import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { productStartAddNew } from '../../../../actions/products'
import { getFloat, getPriceSteamCheck } from '../../../../helpers/fetch'
import { ProductCardStock } from './ProductCardStock'
import { Spin } from './Spin'

export const ModalAdd = ({item,closeModal}) => {
    const dispatch = useDispatch()
    const [destacado, setDestacado] = useState(false)

    const [steamPrice, setSteamPrice] = useState('')
    const [float, setFloat] = useState('')
    
     useEffect(() => {
       
         getPriceSteamCheck(item.market_hash_name).then(res => setSteamPrice(res) )
        //  getPriceSteamCheck(item.market_hash_name).then(res => console.log(res) )

        if(item.tieneFloat){
            // console.log('float')
    
            getFloat(item).then( resp =>  setFloat(resp))
        }
       
        
     }, [item])

     useEffect(() => {
        if(float !== null && float){
            setFormValues( {
                ...item, 
                float: float,
               
            })
    
        }
       
     }, [float])

     useEffect(() => {
      console.log(destacado)
            setFormValues( {
                ...formValues, 
                destacado
            })
    
      
       
     }, [destacado])
     
     
 

 
  let lowestPrice = 0
  let medianPrice = 0
  let precioSugerido



     if(steamPrice !== '' && steamPrice !== undefined){
        //  console.log(steamPrice)
        // console.log(steamPrice)
        if( steamPrice.lowest_price ){

            lowestPrice =( parseFloat(steamPrice.lowest_price.split(' ')[1].replace('.','') ) )
        }
        if(steamPrice.median_price){

            medianPrice = ( parseFloat(steamPrice.median_price.split(' ')[1].replace('.','') ))
    
            precioSugerido =  ( (Math.max((lowestPrice),(medianPrice)) *1.35).toFixed(2) )
            // console.log( (parseFloat(steamPrice.median_price.split(' ')[1])) )
        }else{
            precioSugerido = (lowestPrice * 1.35).toFixed(2)
        }
     }
   
  
    const initialState = {
        ...item, 
        float,
        oferta: 0,
        precio: "",
    }
    const [formValues, setFormValues] = useState(initialState)  



    
    const {precio,cantidad,oferta} = formValues
    

    const handleInputChange = ({target}) => {
        
        setFormValues({
            ...formValues,
            [target.name]: target.value,
        })
      }
    
      const handleSubmitForm = async(e) =>{
          e.preventDefault()

          if(item.tieneFloat){
            // console.log('float')
    
           await getFloat(item).then( resp =>  setFloat(resp))
        }
      
          setFormValues({
            ...formValues
        })

          dispatch( productStartAddNew(formValues) );


          Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Producto guardado',
              showConfirmButton: false,
              timer: 1500
            })
            closeModal()
    }
    
    
  return (
            
            <form 
                    className="container _modal-form row"
                    onSubmit={ handleSubmitForm }
            >
                <h5>Agregar Producto</h5>
               
                <div className="_productCardStock">

                        <div className='card-container'>

                        <ProductCardStock key={item.id+ "ad6m"} item={item} />

                    </div>
                </div>
                <div className='listing-cont btn_green'>
                    <a href={item.listings} target="_blank" > ver en Market Steam <i className="fa-brands fa-steam"></i></a>
                </div>
               
                <div className='priceoverview'>Precio en Market Steam 
                        {steamPrice === ''?
                              <div className='spin-price'>
                                  <Spin />

                              </div>
                            
                                :
                                <div>

                                    <span className='price-steam '>mas bajo actual: AR$ {lowestPrice} </span>
                                    <span className='price-steam '>precio promedio:  AR$ {medianPrice}</span>
                                    <span className='price-steam '>precio sugerido:  AR$ { precioSugerido }</span>

                                </div>
                    
                        }
                </div>
                
                    <div className='row mt-2'>

                        <label htmlFor="precio" className='col-6'>Precio AR$</label>
                        <input 
                            type="number" 
                            className="col-6"
                            id='precio'
                            placeholder="precio"
                            min="0" 
                            name="precio"
                            autoComplete="off"
                            value={precio}
                            onChange={ handleInputChange }
                            required
                        />
                    </div>

                    <div className='row mt-2'>
                        <label htmlFor="cantidad" className='col-6'>Cantidad</label>
                        <input 
                            type="number" 
                            className="col-6"
                            id='cantidad'
                            placeholder="cantidad"
                            min="1" 
                            name="cantidad"
                            autoComplete="off"
                            value={cantidad}
                            onChange={ handleInputChange }
                            required
                            
                        />
                    </div>

                    <div className='row mt-2'>
                        <label htmlFor="oferta" className='col-6'>Oferta %</label>
                    <input 
                        type="number" 
                        className="col-6"
                        placeholder="oferta"
                        min="0" 
                        name="oferta"
                        autoComplete="off"
                        value={oferta}
                        onChange={ handleInputChange }   
                    />
                    </div>
                    <div className='dest-cont mt-2'>
                       
                        <label htmlFor="destacado">Producto destacado</label>
                        {/* <input type="checkbox" id="destacado" onChange={ (e)=>setDestacado(e.target.checked) }  /> */}
                        {destacado&&
                        
                        <input type="checkbox" id="destacado" checked onChange={ (e)=>setDestacado(e.target.checked)}  />
                        }
                        {!destacado&&
                        
                        <input type="checkbox" id="destacado" onChange={ (e)=>setDestacado(e.target.checked)}  />
                        }
                    </div>
                <button
                    type="submit"
                    className="btn_blue mt-2"
                >
                    <i className="far fa-save"></i>
                    <span> Guardar</span>
                </button>
               
            </form>
    
  )
}
